module.exports = __webpack_public_path__ + "static/img/03.bfbf842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hat/03.png
// module id = a45Z
// module chunks = 0